import request from 'src/shared/utils/requester';

const USE_CASE_URL = 'inventory';

const getInventoryList = async ({
  companyHeadquarterId,
  page,
  limit,
  search,
  orderBy,
  filterCriteria
}) => {
  const method = 'GET';
  const url =
    `${USE_CASE_URL}` +
    `?companyHeadquarterId=${companyHeadquarterId}&page=${page}&limit=${limit}&search=${search}&orderBy=${orderBy}&filterCriteria=${filterCriteria}`;

  const json = await request({ method, url });
  return json;
};

export default getInventoryList;
